import { render, staticRenderFns } from "./OrgDefinitions.vue?vue&type=template&id=2f863c3a&scoped=true&"
import script from "./OrgDefinitions.vue?vue&type=script&lang=js&"
export * from "./OrgDefinitions.vue?vue&type=script&lang=js&"
import style0 from "./OrgDefinitions.css?vue&type=style&index=0&id=2f863c3a&prod&scoped=true&lang=css&"
import style1 from "./OrgDefinitions.vue?vue&type=style&index=1&id=2f863c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f863c3a",
  null
  
)

export default component.exports